import * as React from 'react';
import { Wrench } from '@phosphor-icons/react';
import type { Id } from '@/convex';
import { LastScanAffordance } from '@/components/scan-progress';
import s from '../findings.module.scss';

interface PrimaryAction {
  label: string;
  disabled?: boolean;
  title?: string;
  onClick: () => void;
}

export function renderFindingsHeaderActions(args: {
  primaryAction: PrimaryAction | null | undefined;
  selectedProjectId: Id<'projects'> | undefined;
  repoFullName: string | undefined;
  readOnly: boolean;
  onRescan: () => void;
}): React.ReactNode {
  return (
    <>
      <LastScanAffordance
        projectId={args.selectedProjectId}
        repoFullName={args.repoFullName}
        readOnly={args.readOnly}
        onRescan={args.onRescan}
      />
      {args.primaryAction ? (
        <button
          type="button"
          className={s.workbenchPrimaryAction}
          disabled={args.primaryAction.disabled}
          title={args.primaryAction.title}
          onClick={args.primaryAction.onClick}
        >
          <Wrench size={13} />
          {args.primaryAction.label}
        </button>
      ) : null}
    </>
  );
}
